import { render, staticRenderFns } from "./Wise.vue?vue&type=template&id=fd897e3a&scoped=true"
import script from "./Wise.vue?vue&type=script&lang=js"
export * from "./Wise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd897e3a",
  null
  
)

export default component.exports